import { render, staticRenderFns } from "./Openhouse.vue?vue&type=template&id=fa097af2&"
import script from "./Openhouse.vue?vue&type=script&lang=js&"
export * from "./Openhouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports